import { DEG_TO_RAD, Sprite } from 'pixi.js';
import Core from '../../../Core/Core';
import { PopupActions } from '../../../State/Actions/Actions';
import { createPixiText, scaleToFit } from '../../../Utils/Utils';
import { BaseRewardPopup } from './BaseRewardPopup';

export class GiftReceivedPopup extends BaseRewardPopup {
    constructor(width: number, height: number, friendAvatar: string, friendName: string) {
        super(width, height, Core.local.getText('receivedGift'), Core.local.getText('openit'));

        const rays = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/opt-in_icon_rays']);
        rays.anchor.set(0.5);
        rays.scale.set(1.25);
        rays.x = this.innerWidth * 0.7;
        rays.y = this.innerHeight * 0.45;
        this.main.addChild(rays);

        const avatar = new Sprite();
        avatar.anchor.set(0.5);
        avatar.x = this.innerWidth * 0.33;
        avatar.y = this.innerHeight * 0.43;
        avatar.rotation = DEG_TO_RAD * -5.5;
        this.main.addChild(avatar);

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = friendAvatar;
        img.onload = () => {
            avatar.texture = PIXI.Texture.from(img);
            avatar.scale.set(scaleToFit(img.naturalWidth, img.naturalHeight, 125, 125));
        };

        const avatarFrame = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/friend-gift-frame']);
        avatarFrame.anchor.set(0.5);
        avatarFrame.x = this.innerWidth * 0.4;
        avatarFrame.y = this.innerHeight * 0.45;
        this.main.addChild(avatarFrame);

        const giftBox = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/giftbox-closed']);
        giftBox.anchor.set(0.5);
        giftBox.x = this.innerWidth * 0.7;
        giftBox.y = this.innerHeight * 0.42;
        this.main.addChild(giftBox);

        const messageText = createPixiText(
            Core.local.getText('receivedGiftMessage').replace('/player name/', friendName),
            new PIXI.Rectangle(
                this.innerWidth / 2,
                this.innerHeight * 0.5,
                this.innerWidth * 0.9,
                height * 0.2
            ),
            'Baloo',
            30,
            30
        );
        messageText.anchor.set(0.5);
        messageText.position.set(this.innerWidth / 2, this.innerHeight * 0.7);
        this.main.addChild(messageText);
    }

    protected emitPopupCloseAction(): void {
        this.emit(PopupActions.GIFT_RECEIVED_POPUP_CLOSE, 'close');
    }
}
